import React, { useCallback } from 'react';
import { useTranslation } from '../../../../../i18n/useTranslation';

interface TextareaCommentProps {
    placeholder?: string;
    maxLength?: number;
    rows?: number;
    onCommentChange: (comment: string) => void;
    comment?: string;
}

const TextAreaComment: React.FC<TextareaCommentProps> = ({ placeholder, rows = 2, onCommentChange, comment }) => {
    const { t } = useTranslation();

    const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        onCommentChange(value);
    }, [onCommentChange]);

    return (
        <textarea
            name='comment'
            value={comment}
            onChange={handleChange}
            className="w-full bg-white rounded-[20px] p-3 text-base text-bold focus:outline-none resize-none"
            style={{ boxShadow: '0 0 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)' }}
            placeholder={placeholder ?? t('survey.comment_optional')}
            rows={rows}
        />
    );
};

export default TextAreaComment;
